import React from 'react';
import Select from 'react-select';
import BaseApi from '../../api/BaseApi.js';
import ScreenCaption from '../screen-caption.js';
import add from '../../img/add.svg';
import details from '../../img/details.svg';
import sortasc from '../../img/sort-asc.svg';
import sortdesc from '../../img/sort-desc.svg';



export default class VolunteersScreen extends React.Component {

    constructor(props) {
        super(props);

        var locationid = ""
        var selectedLocationId = ""
        var sortField = null
        var sortOrder = null
        var pageCount = 0
        
        const args = props.args === undefined ? {} : props.args
    
        if (args.locationid !== undefined) {
            locationid = args.locationid
            selectedLocationId = locationid
        }

        if (args.pageCount !== undefined) {
            pageCount = args.pageCount
        }

        if (args.sortField !== undefined) {
            sortField = args.sortField
        }

        if (args.sortOrder !== undefined) {
            sortOrder = args.sortOrder
        }

        this.state = {args: args,
                      locationOptions: [],
                      pageLimit: 25, 
                      pageCount: pageCount,   
                      nameCriteria: "",
                      prevNameCriteria:"",
                      locationId: locationid,
                      selectedLocationId: selectedLocationId,
                      sortField: sortField, 
                      sortOrder: sortOrder,
                      volunteers: []};

              

        this.nameSearch = this.nameSearch.bind(this);  
        this.locationChangeHandler = this.locationChangeHandler.bind(this);  
        this.nameCriteriaChangeHandler = this.nameCriteriaChangeHandler.bind(this);  
        this.sortClicked = this.sortClicked.bind(this)

        
        setTimeout(this.nameSearch, 2000);
    }

    async componentDidMount() {
        this.getLocationOptons()
        this.getDataWithCritera()
    }

    locationChangeHandler(selectedOption) {
        var args = this.state.args
        args.pageCount = 0
        this.setState({selectedLocationId: selectedOption.value, pageCount: 0, args: args}, this.getDataWithCritera)
    }

    nameCriteriaChangeHandler(event) {
        this.setState({nameCriteria: event.target.value})
    }

    getDataWithCritera() {

        var parameters = {}

        parameters.location = this.state.selectedLocationId

        if (this.state.nameCriteria.length > 0) {
            parameters.name = this.state.nameCriteria
        }

        parameters.limit = this.state.pageLimit
        parameters.offset = this.state.pageLimit * this.state.pageCount

        if (this.state.sortField) {
            parameters.orderby = this.state.sortField
        }

        if (this.state.sortOrder) {
            parameters.sortorder = this.state.sortOrder
        }

        BaseApi.get('/volunteers', {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, params: parameters, withCredentials: true})
        .then(res => {
            this.setState({volunteers: res.data})
        })    
        .catch(error=>console.log(error))
    }

    getLocationOptons() {
        BaseApi.get("/locations", {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, params: {list: true}, withCredentials: true})
        .then(res => {
            const locationOptions = res.data.map(({id, name}) => ({value: id, label: name}))
            locationOptions.push({value: "", label: "Все"})
            this.setState({locationOptions: locationOptions})
        })    
        .catch()
    }

    nameSearch() {
        if (this.state.nameCriteria !== this.state.prevNameCriteria) {
            var args = this.state.args
            args.pageCount = 0
            this.setState({prevNameCriteria: this.state.nameCriteria, pageCount: 0, args: args}, this.getDataWithCritera)
        }    
        setTimeout(this.nameSearch, 2000)
    }

    nextPage() {
        var args = this.state.args
        args.pageCount = this.state.pageCount + 1
        this.setState({pageCount: this.state.pageCount + 1}, this.getDataWithCritera)
    }

    prevPage() {
        if (this.state.pageCount > 0) {
            var args = this.state.args
            args.pageCount = this.state.pageCount - 1
            this.setState({pageCount: this.state.pageCount - 1, args: args}, this.getDataWithCritera)
        }
    }

    sortClicked(event) {
        var currentField = this.state.sortField
        var currentOrder = this.state.sortOrder
        switch (event.target.id) {
            case "locationCaption" :
                if (currentField === "location") {
                    if (currentOrder !== "desc") {
                        currentOrder = "desc"
                    } else {
                        currentOrder = "asc"
                    }
                } else {
                    currentField = "location"
                    currentOrder = "asc"
                }
            break
            case "nameCaption" :
                if (currentField === "name") {
                    if (currentOrder !== "desc") {
                        currentOrder = "desc"
                    } else {
                        currentOrder = "asc"
                    }
                } else {
                    currentField = "name"
                    currentOrder = "asc"
                }
            break     
        }
        var args = this.state.args
        args.pageCount = 0
        args.sortField = currentField
        args.sortOrder = currentOrder
        this.setState({sortField: currentField, sortOrder: currentOrder, pageCount: 0}, this.getDataWithCritera)
    }

    openVolunteer(id) {
        this.props.navigate("volunteer", {caller: "volunteers", callargs: this.state.args, volunteer: id})
    }

    isFieldSortedDesc(field) {
        return this.state.sortField === field && this.state.sortOrder === "desc"
    }

    isFieldSortedAsc(field) {
        return this.state.sortField === field && this.state.sortOrder !== "desc"
    } 
    
    renderVolunteer(volunteer) {
    
        return (
            <tr
                key={volunteer.id}
                className="table-row-clickable"
                onClick={()=>this.openVolunteer(volunteer.id)}
            >
                <td style={{textAlign: 'left',  padding: '4px'}}>{volunteer.region}</td>
                <td style={{textAlign: 'left',  padding: '4px'}}>{volunteer.location}</td>
                <td style={{textAlign: 'left',  padding: '4px'}}>{volunteer.name}</td>
            </tr>
        )        
    }

    render() {
        return (
            <div class="container">
                <ScreenCaption goback={this.props.goback} args={this.state.args} caption={"Волонтеры"}/>

                <div className="row mt-4 mb-3">
                    <div className="col-lg-6">
                        <div className="card shadow-sm">
                            <div className="card-body">
                                <h6 className="card-title mb-3">Фильтр</h6>

                                <div className="className=mb-3">
                                    <label for="name"> Имя:</label>
                                    <input type="text" class="form-control" id="name" value={this.state.nameCriteria} onChange={this.nameCriteriaChangeHandler} />
                                </div>
                                <div className="className=mb-3"> 
                                    <label for="location">Локация:</label>
                                    <Select options= {this.state.locationOptions} 
                                            id="location" 
                                            onChange={this.locationChangeHandler}
                                            />
                                </div>     

                            </div>
                        </div>
                    </div>

                    <div className="col-lg-6 d-flex flex-column align-items-end mt-3 mt-lg-0">
                        <div className="mb-2">
                            <button
                                type="button"
                                className="btn btn-primary d-flex align-items-center"
                                onClick={()=>{this.openVolunteer("")}}
                            >
                                Добавить волонтера
                            </button>
                        </div>
                        <div>
                            <button
                                type="button"
                                className="btn btn-outline-secondary btn-sm me-2"
                                onClick={() => this.prevPage()}
                                disabled={this.state.pageCount === 0}
                            >
                                Предыдущие
                            </button>
                            <button
                                type="button"
                                className="btn btn-outline-secondary btn-sm"
                                onClick={() => this.nextPage()}
                            >
                                Следующие
                            </button>
                        </div>

                    </div>
                </div>    

                {/* Подсказка */}
                <p className="text-muted mb-2" style={{ fontSize: "0.9rem" }}>
                    Нажмите на строку, чтобы открыть карточку волонтера
                </p>

                <div className="card shadow-sm">
                    <div className="card-body p-0">
                        <div className="table-responsive">
                            <table className="table table-sm table-hover mb-0 align-middle">
                                <thead className="table-primary">
                                    <tr>
                                        <th style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                                                Регион
                                        </th>

                                        <th id="locationCaption" 
                                            style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}
                                            onClick={this.sortClicked}>
                                                Локация{" "}
                                                {this.isFieldSortedDesc("location") && <img src={sortdesc} height="16" width="16"/>}
                                                {this.isFieldSortedAsc("location") && <img src={sortasc} height="16" width="16"/>}
                                        </th>
                                        
                                        <th id="nameCaption"    
                                            style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}
                                            onClick={this.sortClicked}>
                                                ФИО{" "}
                                                {this.isFieldSortedDesc("name") && <img src={sortdesc} height="16" width="16"/>}
                                                {this.isFieldSortedAsc("name") && <img src={sortasc} height="16" width="16"/>}
                                        </th> 
                                    </tr>
                                </thead>
                                <tbody>
                                     {this.state.volunteers.map((value, index) => this.renderVolunteer(value))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            
                {/*
                <div class="row" style={{"height" : "50px"}}>
                
                    <div class="col-3 text-left border border-white" 
                            style={{"background-color" : "#0ee"}}>
                            Регион
                    </div>

                    <div class="col-3 text-left border border-white" 
                            id="locationCaption" 
                            style={{"background-color" : "#0ee"}}
                            onClick={this.sortClicked}>
                            Локация
                        {this.isFieldSortedDesc("location") && <img src={sortdesc} height="16" width="16"/>}
                        {this.isFieldSortedAsc("location") && <img src={sortasc} height="16" width="16"/>}
                        
                    </div>
                     
                    <div class="col-4 text-left border border-white"
                         id="nameCaption"    
                         style={{"background-color" : "#0ee"}}
                         onClick={this.sortClicked}>
                            ФИО
                            {this.isFieldSortedDesc("name") && <img src={sortdesc} height="16" width="16"/>}
                            {this.isFieldSortedAsc("name") && <img src={sortasc} height="16" width="16"/>}
                    </div>
                    <div class="col-1 border border-white"
                         id="detailCaptuon" 
                         style={{"background-color" : "#0ee"}}
                         onClick={()=>{this.openVolunteer("")}}>
                         <img src={add} height="16" width="16"/>
                    </div>     
                </div>    
                */}
            </div> 
        )
    }
}    


// WEBPACK FOOTER //
// ./src/ui/workspace-screens/volunteers.js